<template>
  <Modal>
    <Modal.Title>Change name</Modal.Title>
    <Modal.Body>
      <div class="flex flex-col gap-4">
        <Input
          v-model="firstName"
          size="xl"
          label="First name"
          :disabled="loading"
        />
        <Input
          v-model="lastName"
          size="xl"
          label="Last name"
          :disabled="loading"
        />
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :disabled="loading" @click="close()">
        Cancel
      </Button>
      <Button
        variant="primary"
        :disabled="!canSave"
        :loading="loading"
        @click="handleSave"
      >
        Save
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Input, Button, useModal } from '@dacr/library'
import type { User } from '@/shared/graphql/legacy/generated'
import { useChangeName } from './useChangeName'

const { close } = useModal()

const props = defineProps<{
  user: User
}>()

const { firstName, lastName, loading, canSave, save } = useChangeName(
  props.user
)

const handleSave = async () => {
  if (await save()) close()
}
</script>
